import { IArtistSection } from '@/types'
import { MarkdownContent } from 'components/artists/MarkdownContent'
import { CollapsableTextContent } from 'components/common/CollapsableTextContent'
import { Separator } from 'components/common/Separator'
import { Fragment } from 'react'

interface Props {
  sections?: IArtistSection[]
}

export function ArtistSections({ sections = [] }: Props) {
  if (!sections?.length) return null

  return (
    <div className='bg-warm-50 py-12'>
      <div className='container'>
        {sections.map((s, index) => (
          <Fragment key={s.id}>
            <section>
              <CollapsableTextContent>
                <MarkdownContent>{s.text}</MarkdownContent>
              </CollapsableTextContent>
            </section>

            {index !== sections.length - 1 && (
              <Separator className='my-8' color='cool-400' />
            )}
          </Fragment>
        ))}
      </div>
    </div>
  )
}
